import { Modal } from "../../common";
import { Button } from "../../App.styles";
import { useTranslation } from "react-i18next";

const TransformationsModelModal = ({ onDismiss, show }) => {
    const { t } = useTranslation();

    return (
        <Modal onDismiss={onDismiss} show={show}>
            <div className="modal-header">
                <h4 className="modal-title">{t('Transformations Model')}</h4>
                <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-hidden="true"
                    onClick={onDismiss}
                >
                    ×
                </button>
            </div>
            <div className="modal-body">
                <p>{t('This is the model that will be used to make your photo transformations.')}</p>
                <ul>
                    <li>{t('Try them both out before your event to see what works best for your use case.')}</li>
                    <li>{t('New models will be added over time, always check your templates after cloning an older game.')}</li>
                </ul>
            </div>
            <div className="modal-footer">
                <Button onClick={onDismiss}>{t('Close')}</Button>
            </div>
        </Modal>
    );
};

export default TransformationsModelModal;

